/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import { useReactToPrint } from "react-to-print";
import React, { useEffect, useRef, useState } from "react";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";

import Card from "../../../../components/Card";
import excel from "../../../../icons/excel.png";
import print from "../../../../icons/print.png";
import Minimap from "../../../../components/map/Minimap";
import Chart2 from "../../../../components/Charts/Chart2";
import { header } from "../../../../components/api/Header";
import { ExcelPrint } from "../../../../components/functions/Print";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

function Dekadalik({ region, vaqt, search, havza }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState("");

  const [year, setYear] = useState(new Date().toISOString().slice(0, 4));
  const [lyear, setLyear] = useState(year);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/asosiymanbalar/dekadalik?year=" +
            year +
            "&vaqt=" +
            vaqt +
            "&havza=" +
            havza,
          header()
        );
        if (res) {
          if (region === "Gidromet" && havza === 1) {
            setData(res.data.slice(23, 48).concat(res.data.slice(59, 63)));
          } else if (region === "Gidromet" && havza === 2) {
            setData(
              res.data
                .slice(0, 23)
                .concat(res.data.slice(31, 35), res.data.slice(48, 59))
            );
          } else {
            setData(res.data);
          }
        }
      } catch (e) {
        console.log("Xato", e);
        alert("Serverga ulanishda xato!");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [year, vaqt, havza]);

  useEffect(() => {
    setYear(lyear);
  }, [lyear]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const close = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
    setSelectedRowKeys("");
  };

  const months = [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "Iyun",
    "Iyul",
    "Avgust",
    "Sentyabr",
    "Oktyabr",
    "Noyabr",
    "Dekabr",
  ];

  const labels = months.flatMap((month) =>
    ["I", "II", "III"].map((dec) => `${month}(${dec})`)
  );

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Asosiy manbalar",
  });

  return (
    <>
      <div className='table-box'>
        <div className='table-content-top'>
          <div className='table-top-left'>
            <Input
              prefix={<SearchOutlined className='site-form-item-icon' />}
              placeholder='Search'
              onChange={(e) => search(e.target.value)}
            />
          </div>

          <ul className='table-top-right'>
            <li>
              <div className='d-flex'>
                <input
                  type='number'
                  className='form-control form-control-sm'
                  value={lyear}
                  onChange={(e) => setLyear(e.target.value)}
                />
              </div>
            </li>

            <li>
              <button className='btn p-0' onClick={() => generatePDF()}>
                <img src={print} alt='404' />
              </button>
            </li>

            <li>
              <button
                className='btn p-0'
                onClick={() =>
                  ExcelPrint("Asosiy manbalar " + region, year, "tblData")
                }>
                <img src={excel} alt='404' />
              </button>
            </li>
          </ul>
        </div>

        {loading ? (
          <LoadingCard loading={loading} heightSize='80vh' />
        ) : (
          <div id='content'>
            <div
              id='tableFlexible'
              style={{ height: selectedRowKeys === "" ? "80vh" : "38vh" }}>
              <div ref={conponentPDF} style={{ width: "100%" }}>
                <table
                  id='tblData'
                  className='table table-bordered table-style fixedHeader'>
                  <thead className=''>
                    <tr>
                      <th rowSpan={2} className='sticky st1'>
                        o
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "31px" }}>
                        T/R
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "71px", width: "250px" }}>
                        Irrigatsiya tizimlari nomi va asosiy suvolish nuqtalari
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "368px" }}>
                        O’lchov birligi
                      </th>

                      <th colSpan={3}>Yanvar</th>

                      <th colSpan={3}>Fevral</th>

                      <th colSpan={3}>Mart</th>

                      <th colSpan={3}>Aprel</th>

                      <th colSpan={3}>May</th>

                      <th colSpan={3}>Iyun</th>

                      <th colSpan={3}>Iyul</th>

                      <th colSpan={3}>Avgust</th>

                      <th colSpan={3}>Sentyabr</th>

                      <th colSpan={3}>Oktyabr</th>

                      <th colSpan={3}>Noyabr</th>

                      <th colSpan={3}>Dekabr</th>
                    </tr>

                    <tr>
                      {Array(36)
                        .fill()
                        .map((_, i) => {
                          return <th key={i}>{decade(i)}</th>;
                        })}
                    </tr>
                  </thead>

                  {data.length > 0
                    ? data.map((d, index) => {
                        return (
                          <tbody key={index}>
                            <tr
                              onClick={() => chiz(index)}
                              className={"tr tr" + index}>
                              <td className='sticky st1'>
                                <input type='checkbox' />
                              </td>

                              <td className='sticky' style={{ left: "31px" }}>
                                {index + 1}
                              </td>

                              <td
                                className='text-start sticky fix-with'
                                style={{ left: "71px" }}>
                                {d.manba_nomi}
                              </td>

                              <td
                                className='text-start sticky'
                                style={{ left: "368px" }}>
                                {d.birligi}
                              </td>

                              {d.data
                                ? d.data.map((s, i) => {
                                    return (
                                      <td
                                        style={{
                                          width: "100px",
                                          maxWidth: "100px",
                                          minWidth: "100px",
                                        }}
                                        key={i}>
                                        {s}
                                      </td>
                                    );
                                  })
                                : Array(36)
                                    .fill()
                                    .map((i) => {
                                      return (
                                        <td
                                          style={{
                                            width: "100px",
                                            maxWidth: "100px",
                                            minWidth: "100px",
                                          }}
                                          key={i}></td>
                                      );
                                    })}
                            </tr>
                          </tbody>
                        );
                      })
                    : null}
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      {selectedRowKeys.length === 0 ? null : (
        <div
          className='data-content mt-3 mainpage'
          style={{ position: "relative" }}>
          <CloseOutlined
            style={{
              position: "absolute",
              top: 0,
              right: 10,
              zIndex: 9,
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={close}
          />

          <Card>
            {data[selectedRowKeys].lat !== null &&
            data[selectedRowKeys].lan !== null ? (
              <Minimap
                location={[
                  data[selectedRowKeys].lat,
                  data[selectedRowKeys].lan,
                ]}
                locations={[]}
                zoom={13}
              />
            ) : null}
          </Card>

          <Chart2 datas={data[selectedRowKeys]["data"]} labels={labels} />
        </div>
      )}
    </>
  );
}

export default Dekadalik;

const decade = (i) => {
  let s = (i % 3) + 1;
  if (s == 1) return "I";
  if (s == 2) return "II";
  if (s == 3) return "III";
};
